import React from 'react';
import { Link, LinkProps, useNavigate } from 'react-router-dom';
import { useRootEditActions } from '@/components/provider/RootEditProvider/RootEditProvider.context';

type SafeLinkProps = LinkProps & {};

const SafeLink = ({ to, onClick, ...rest }: SafeLinkProps) => {
    const navigate = useNavigate();
    const { guardNavigateLink } = useRootEditActions();

    return (
        <Link
            to={to}
            {...rest}
            onClick={(e) => {
                onClick?.(e);
                if (e.defaultPrevented) return;

                if (
                    e.button !== 0 ||
                    e.metaKey ||
                    e.altKey ||
                    e.ctrlKey ||
                    e.shiftKey
                ) {
                    return;
                }

                e.preventDefault();

                const toStr = typeof to === 'string' ? to : (to.pathname ?? '');
                guardNavigateLink(toStr, () => navigate(to));
            }}
        />
    );
};

export default SafeLink;
